import { AppliedPolicyStatusType } from '@/react/portainer/environments/types';

/**
 * Mapping from policy status enum values to user-friendly display labels.
 * Use this as the single source of truth for status display names.
 */
export const statusLabelMap: Record<AppliedPolicyStatusType, string> = {
  [AppliedPolicyStatusType.Applied]: 'Active',
  [AppliedPolicyStatusType.Warning]: 'Warning',
  [AppliedPolicyStatusType.Failed]: 'Failed',
  [AppliedPolicyStatusType.InProgress]: 'In progress',
  [AppliedPolicyStatusType.NotSupported]: 'Not supported',
};

/**
 * Get the display label for a policy status.
 * @param status - The policy status enum value
 * @returns Human-readable display label
 */
export function getStatusDisplayLabel(status: AppliedPolicyStatusType): string {
  return statusLabelMap[status] ?? status;
}

/**
 * Get options array for status filter dropdown.
 * @returns Array of {value, label} options for select components
 */
export function getStatusOptions(): Array<{
  value: AppliedPolicyStatusType;
  label: string;
}> {
  return Object.entries(statusLabelMap).map(([value, label]) => ({
    value: value as AppliedPolicyStatusType,
    label,
  }));
}
